<template>
  <div class="p-the-j05-chat-screen">
    <div class="p-the-j05-chat-screen__chat">
      <div
        class="p-the-j05-chat-screen__chat__item"
        v-for="(chat, key) in chatLog"
        :key="chat.rowNo"
        :id="`chat-${chat.rowNo}`"
      >
        <div
          v-if="chat.rowNo === unreadRowNo"
          class="p-unread-line"
        >
          未読メッセージ
       </div>
        <J05ChatScreenPanel
          :chat-data="{
            ...chat,
            key,
            chatLog 
          }"
          :unread-key-no="unreadRowNo"
          :partner-user-image="partnerUserImage"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import J05ChatScreenPanel from "@/general/components/pages/parts/ThanksPointMessage/J05ChatScreenPanel.vue";
import { Options, Vue } from 'vue-class-component';
import { ChatLogItem } from "@/general/store/models";

@Options({
  props: {
	chatLog: { type: Array, required: true },
	unreadRowNo: { type: Number, required: true },
	partnerUserImage: { type: String, required: false, default: "" }
  },
  components: {
    J05ChatScreenPanel
  }
})
export default class TheJ05ChatScreen extends Vue {
  chatLog!: ChatLogItem[];
  unreadRowNo!: number;
  partnerUserImage!: string;
}
</script>

<style lang="scss" scoped>
.p-the-j05-chat-screen {
  @include pc {
    padding: rem(40) 0;
  }
  @include sp {
    padding: rem(24) 0;
  }

  &__chat {
    &__item {
      & + & {
        margin-top: rem(16);
      }
    }
  }
}

.p-unread-line {
  display: flex;
  align-items: center;

  margin: 24px 0;

  color: #d83b01;
  font-size: 12px;
  font-weight: 700;

  &::before,
  &::after {
    content: "";

    flex: 1;

    height: 1px;

    background: #d83b01;
  }

  &::before {
    margin-right: 12px;
  }

  &::after {
    margin-left: 12px;
  }
}
</style>
